import React, { useState, useEffect } from "react"
import InlineGenericLinkComponent from "./InlineGenericLinkComponent"
import "react-dates/lib/css/_datepicker.css"
import Icon from "../../icon/icon.component.jsx"
import ActionButton from "../../button/actionbutton.component.jsx"
import { ActionLog, ACTION_SENT, ACTION_SUCCESS } from "../../../state/actionlog/ActionLog"

type OwnProps = {
    valueObject: React.ReactNode,
    inputObject: React.ReactNode,
    onSave: (string) => void,
	action: ActionLog,

    popupClassName?: string,
    popupStyle?: React.CSSProperties,
}

const ACTION_TIME = 1500
const InlineGenericEditComponent = (props: OwnProps) => {
    const [toggle, setForceUpdate] = useState(false)
    const [editMode, setEditMode] = useState<boolean>(false)

    const isActionRecent = (Date.now() - props.action.time) < ACTION_TIME
    const actionStatus = props.action.status
    useEffect(() => {
        if (actionStatus == ACTION_SUCCESS) {
            setEditMode(false)
            const update = setTimeout(() => setForceUpdate(!toggle), ACTION_TIME)
            return function cleanup() { clearTimeout(update) }
        }
    }, [props.action])

    return (
        <span>
            <InlineGenericLinkComponent
                editMode={editMode}
                success={actionStatus == ACTION_SUCCESS && isActionRecent}
                setEditMode={setEditMode}
            >
                {props.valueObject}
            </InlineGenericLinkComponent>
            <div 
                style={props.popupStyle} 
                className={props.popupClassName + " dropdown-menu p-4 col-md-4 " + (editMode ? "show" : "")}
            >
                {props.inputObject}
                <p className="m-0 pt-2">
                    <button className="btn btn-sm btn-outline-secondary" onClick={() => setEditMode(!editMode)}>
                        <Icon value={"arrow-left"} />
                    </button>

                    <ActionButton
                        className="btn btn-sm btn-outline-primary ml-2"
                        onClick={props.onSave}
                        isLoading={actionStatus == ACTION_SENT}
                    >
                        <Icon value={"save"} />
                    </ActionButton>
                </p>
            </div>
        </span>
    )
}

export default InlineGenericEditComponent


// WEBPACK FOOTER //
// ./src/common/inline-edit/component/InlineGenericEditComponent.tsx